import React from "react";
import Button from "core/buttons/button/Button";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const ClearFiltersButton = ({
  onClear,
  hasActiveFilters,
  labelId = "clear_my_filters",
  defaultLabel = "Supprimer mes filtres",
  color = "btn btn-common btn-medium btn-outlined white",
  id = "clear-filters-btn",
  className = "",
}) => {
  return (
    <Button
      color={color}
      type="button"
      id={id}
      onClick={onClear}
      disabled={!hasActiveFilters()}
      className={className}
    >
      <FormattedMessage id={labelId} defaultMessage={defaultLabel} />
    </Button>
  );
};

ClearFiltersButton.propTypes = {
  onClear: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.func.isRequired,
  labelId: PropTypes.string,
  defaultLabel: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default ClearFiltersButton;
